import * as React from 'react';
import { OfferCard } from './components/OfferCard';
import { ClusterModal } from './components/ClusterModal';
import { ClusterCarousel } from './components/ClusterCarousel';
import { ClusterLayout } from './components/ClusterLayout';
import { OfferList } from './components/OfferList/OfferList';
import { ICluster, ICLusterOffer } from '../../types/cluster';

interface IClusterContainerProps {
  cluster?: ICluster;
}
export function ClusterContainer({ cluster }: IClusterContainerProps) {
  const navRef = {
    next: React.useRef<HTMLButtonElement>(null),
    prev: React.useRef<HTMLButtonElement>(null),
  };

  const [isVisibleModal, setIsVisibleModal] = React.useState(false);
  const [activeOffer, setActiveOffer] = React.useState<ICLusterOffer | null>(null);

  const handleOfferCardClick = (feature: ICLusterOffer) => {
    setActiveOffer(feature);
    setIsVisibleModal(true);
  };

  if (!cluster) {
    return null;
  }

  return (
    <>
      <ClusterLayout
        description={cluster.description}
        navRef={navRef}
        carousel={
          <ClusterCarousel navRef={navRef}>
            {cluster.features.map(feature => {
              return (
                <OfferList
                  key={feature.id}
                  offersLength={feature.offers.length}
                  offers={feature.offers.map(item => (
                    <OfferCard key={item.id} offer={item} onClick={handleOfferCardClick} />
                  ))}
                />
              );
            })}
          </ClusterCarousel>
        }
      />
      {activeOffer && (
        <ClusterModal
          open={isVisibleModal}
          onClose={setIsVisibleModal}
          content={activeOffer.description}
          imageUrls={activeOffer.media}
          pins={activeOffer.pins}
          modalTitle={`${cluster.title} кластер`}
          title={activeOffer.title}
        />
      )}
    </>
  );
}
